/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ServerContext } from "~/types";

const getServerContext: () => ServerContext = () => {
  const contextText = document.getElementById("context")?.innerText ?? "{}";

  return JSON.parse(contextText) as ServerContext;
};

export default getServerContext;
